// default feature config values sent to useFeatures provider
export default {
  brand: {
    enabled: true,
    variables: {
      brand_name: 'Autotrader',
      channel: 'ATC',
      leads_cc_flag: true,
      leads_partner_name: 'ConsumerSite',
      visitor_agreement_link: 'https://www.autotrader.com/legal/visitor-agreement'
    }
  },
  email_opt_in: {
    enabled: true,
    variables: {
      label: 'Yes, I would like to receive price alerts on this vehicle and helpful shopping information from Autotrader & its affiliates.'
    }
  },
  chat: {
    enabled: true,
    variables: {
      providers: ['GUBAGOO', 'ACTIVENGAGE'],
      gubagoo_base_url: 'https://cdn.gubagoo.io/toolbars/integration/AT_',
      enable_mobile_chat: false,
      hide_sticky_invitation: false,
      ae_account_url: 'autotrader.com'
    }
  },
  my_wallet: {
    enabled: true,
    variables: {
      show_articles: true,
      show_ico: true
    }
  }
};